import { dequal } from "dequal";

/**
 * Deep structural equality check.
 * Returns true when `a` and `b` are recursively equal by value.
 * Backed by `dequal` which handles objects, arrays, Date, RegExp, Map, Set, etc.
 */
export function deepEqual(a: unknown, b: unknown): boolean {
    return dequal(a, b);
}
